export const classItemSx = {
  statusBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: '6px',
    px: '16px',
    borderRadius: '8px',
    my: '10px',
  },
  statusText: {
    fontSize: "13px",
    fontWeight: "bold",
    textTransform: 'uppercase',
    color: 'primary.contrastText',
  },
  statusPlaceholder: {
    height: '32px',
    my: '10px',
  },
  courseTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    textTransform: 'capitalize',
    textAlign: "center",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minHeight: "48px",
    lineHeight: "24px",
  },
  cohortText: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  dateText: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  enterButton: {
    textTransform: 'capitalize',
    mt: 2,
    ml: 2
  },
  detailsButton: {
    textTransform: 'capitalize',
    mt: 2
  },
  buttonWrapper: {
    mt: 2,
    minHeight: 40,
    display: "flex",
    alignItems: "center"
  },
  tryAgainButton: {
    textTransform: "capitalize",
    backgroundColor: "green",
    "&:hover": { backgroundColor: "green" },
  },
  refundButton: {
    textTransform: 'capitalize',
    backgroundColor: 'red',
    '&:hover': {
      backgroundColor: 'darkred',
    },
  },
  placeholderBox: {
    height: 36,
    minWidth: 120
  }
};
